import React from 'react';
import { api, globalErrorHandler } from '../../api/create-api';
import { makeCall } from '../../auth-utils';
import { useToasts } from 'react-toast-notifications';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

export const InvitedUsers = (props) => {
    const { users, ReloadResources } = props;
    const { addToast, removeToast } = useToasts();

    const deleteUser = async (id) => {
        makeCall(async (authHeader) => {
            addToast('Deleting User', { appearance: 'info', id: 'deleting-user' });
            await api.delete(`api/users/${id}`, {
                headers: authHeader
            }).catch((error) => globalErrorHandler(error, addToast));
            removeToast('deleting-user', () => {
                ReloadResources();
            });
        });
    };

    return (
        <div className="text-right text-dark d-flex">
            <div className="flex-fill"></div>
            <div>
                <p className="border-bottom pb-1 mb-0 pl-2">
                    Invited Users
            </p>
                <ListGroup flush>
                    {users.map(user => <ListGroupItem key={user.id} className="font-italic">{user.email} <FontAwesomeIcon className="cursor-pointer" icon={faTimesCircle} onClick={() => deleteUser(user.id)} /></ListGroupItem>)}
                </ListGroup>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Users/InvitedUsers.js